module.exports = __webpack_public_path__ + "img/Rent.881d5afb.svg";